// TOPLU KOPYALAMA — başarı bildiriminde satır içi "GERİ AL".
// Zaman penceresi KULLANILMAZ: yalnızca bu kopyalamada oluşan kopyaların
// `task_duplicate` işlem kayıtları hedeflenir (başka işlem geri alınmaz).
import { toast } from "sonner";
import { activityApi, tasksApi } from "./api";

// TEK ANAHTAR: satır içi GERİ AL'ı kapatmak için bunu false yap → normal
// başarı bildirimi gösterilir, başka dosyaya dokunmak gerekmez.
export const SATIR_ICI_GERI_AL_ACIK = true;
const TOAST_SURE_MS = 10000; // kullanıcı kararı: 10 saniye

const bekle = (ms) => new Promise((r) => setTimeout(r, ms));

// İşlem kaydı backend'de ARKA PLANDA yazılır; hemen basılırsa henüz
// görünmeyebilir → kısa aralıklarla birkaç kez denenir.
async function kayitlariBul(copyIds) {
  for (let deneme = 0; deneme < 4; deneme += 1) {
    const { items = [] } = await activityApi.list(100);
    const bulunan = items.filter(
      (k) => k.action === "task_duplicate" && !k.undone && copyIds.includes(k.entity_id),
    );
    if (bulunan.length) return bulunan;
    await bekle(700);
  }
  return [];
}

async function geriAl(copyIds, refresh, kilit) {
  if (kilit.calisiyor) return; // senkron kilit: ikinci istek gitmez
  kilit.calisiyor = true;
  try {
    const kayitlar = await kayitlariBul(copyIds);
    if (!kayitlar.length) {
      toast.error("Geri alınamadı: kopyalama işlem kaydı bulunamadı — GERİ AL menüsünü kullanın", {
        duration: 9000,
      });
      return;
    }
    await Promise.allSettled(kayitlar.map((k) => activityApi.undo(k.id, true)));
    // DOĞRULAMA: sahte başarı yok — kopyalar gerçekten çöp kutusunda mı?
    let cope = [];
    try {
      const cop = await tasksApi.list(false, "mine", "trash");
      const liste = Array.isArray(cop) ? cop : cop?.items || [];
      cope = liste.filter((t) => copyIds.includes(t.id)).map((t) => t.id);
    } catch (e) {
      console.warn("[bulkCopyUndo] çöp doğrulaması yapılamadı:", e);
    }
    refresh?.();
    if (cope.length === copyIds.length) {
      toast.success("Kopyalama geri alındı");
    } else if (cope.length) {
      toast.error(`${cope.length} kopya geri alındı · ${copyIds.length - cope.length} geri alınamadı`, {
        duration: 9000,
      });
    } else {
      toast.error("Geri alınamadı — kopyalar hâlâ listede. GERİ AL menüsünden deneyin", {
        duration: 9000,
      });
    }
  } finally {
    kilit.calisiyor = false;
  }
}

export function kopyaGeriAlBildirimi(copyIds, mesaj, refresh) {
  if (!SATIR_ICI_GERI_AL_ACIK) {
    toast.success(mesaj);
    return;
  }
  const kilit = { calisiyor: false };
  toast.success(mesaj, {
    duration: TOAST_SURE_MS, // süre bitince kapanır; ana GERİ AL menüsü yine kullanılabilir
    action: { label: "GERİ AL", onClick: () => geriAl(copyIds, refresh, kilit) },
  });
}
